import Vue from "vue";
import {BASE_URL, ENDPOINT_URL, REQUEST_API} from "./api";
import { addQueryToUrl } from "./util";
import {DOMAIN_AGENT_LINE, DOMAIN_INVITE_CODE} from "./constant";

export function userConfig1(params) {
  return new Promise((resolve, reject) => {
    Vue.http.get(`${BASE_URL}${REQUEST_API.userConfig}`, params).then(
      res => {
        resolve(res);
      },
      error => {
        reject(error);
      }
    );
  });
}
// 获取邀请码
export function getInviteCodeFile() {
  return new Promise((resolve, reject) => {
    Vue.http.get(`/land/invitedCode.json`).then(
      res => {
        resolve(res);
      },
      error => {
        reject(error);
      }
    );
  });
}
// 获取ga code 码
export function getGatagFile() {
  return new Promise((resolve, reject) => {
    Vue.http.get(`/land/gtag.json`).then(
      res => {
        resolve(res);
      },
      error => {
        reject(error);
      }
    );
  });
}

// 获取主站域名列表
export function getDomainList() {
  return new Promise((resolve, reject) => {
    Vue.http.get(`/file/domain/8b.json`).then(
      res => {
        resolve(res);
      },
      error => {
        reject(error);
      }
    );
  });
}

export function userRegister(params, data) {
  const reqUrl = data ? `${BASE_URL}${addQueryToUrl(data, REQUEST_API.userRegister)}` : `${BASE_URL}${REQUEST_API.userRegister}`
  return new Promise((resolve, reject) => {
    Vue.http.post(reqUrl, params).then(
        res => {
          resolve(res);
          if (res.data.code === 0) {
            sendEndPoint({
              "user_id": params.userName,
              "phone": '',
              "email": '',
              "agent_line": DOMAIN_INVITE_CODE[location.host],
              "source": "888b",
            })
          }
        },
        error => {
          reject(error);
        }
      );
  });
}

export function userLogin(params) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${BASE_URL}${REQUEST_API.userLogin}`, params).then(
      res => {
        resolve(res);
        if (res.data.code === 0){
          sendEndPoint({
            "user_id": params.userName,
            "agent_line": DOMAIN_INVITE_CODE[location.host],
            "source": "888b",
          },false)
        }
      },
      error => {
        reject(error);
      }
    );
  });
}

export function createCustomer(params) {
  return new Promise((resolve, reject) => {
    Vue.http.post(REQUEST_API.createCustomer, params).then(
      res => {
        resolve(res);
      },
      error => {
        reject(error);
      }
    );
  });
}

export function sendEndPoint(params,isReg=true) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${ENDPOINT_URL}${isReg ? REQUEST_API.endpointReg : REQUEST_API.endpointLogin}`, params).then(
      res => {
        resolve(res);
      },
      error => {
        reject(error);
      }
    );
  });
}

export function getCapCode() {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${BASE_URL}${REQUEST_API.getCodeImg}`).then(
      res => {
        resolve(res);
      },
      error => {
        reject(error);
      }
    );
  });
}

export function getGaCode(params) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${BASE_URL}${REQUEST_API.getGa}`,params).then(
      res => {
        resolve(res);
      },
      error => {
        reject(error);
      }
    );
  });
}






// WEBPACK FOOTER //
// ./src/utils/request.js